import{BaseError as o}from"./base.js";class s extends o{constructor(){super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.",{docsPath:"/docs/clients/intro"})}}export{s as UrlRequiredError};
